import { render, staticRenderFns } from "./ModalCadastroGrupoAvaliacao.vue?vue&type=template&id=d47c7bac"
import script from "./ModalCadastroGrupoAvaliacao.vue?vue&type=script&lang=js"
export * from "./ModalCadastroGrupoAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports